export const valuesSelector = state => state.editing && state.editing.values && state.editing.values;
